interface iTitle {
  children?: any,
  light?: boolean,
  className?: string
}

function Title({children, light=true, className=''}:iTitle) {
  return (
    <div className={`text-[28px] sm:text-3xl lg:text-4xl xl:text-[48px] ${light ? 'font-light' : 'font-regular'} font-geist-mono text-white leading-tight tracking-tighter`}>
      <div className={className}>
        {children}
      </div>
    </div>
  );
}

export default Title;